import React, { Component } from 'react';

export default class ChangePostcodeModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            longitude: this.props.job.lng,
            latitude: this.props.job.lat,
        };
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
    };

    stopPropagation = (e) => {
        e.stopPropagation();
    };

    savePostcode = (e) => {
        e.stopPropagation();

        let formData = new FormData();
        formData.append('postcode', this.state.postcode);
        formData.append('lat', this.state.latitude);
        formData.append('lng', this.state.longitude);

        if (!this.state.latitude || !this.state.longitude) {
            toastr.error('Please fill in all the fields');
            return;
        }

        if (
            this.state.latitude > 60.0 ||
            this.state.latitude < 49.9 ||
            this.state.longitude > 2.0 ||
            this.state.longitude < -8.0
        ) {
            toastr.error('Location is outside of UK. Consider switching fields around?');
            return;
        }

        axios
            .post(`/jobs/${this.props.job.id}/postcode-location`, formData)
            .then((res) => {
                toastr.success('Postcode saved successfully');
                window.location.reload();
            })
            .catch((err) => {
                toastr.error('There was a problem, please try again');
            });
    };

    render() {
        return (
            <div
                className="admin-notes-modal"
                onClick={(e) => {
                    e.stopPropagation();
                }}
            >
                <div className="admin-notes-modal-body">
                    <div className="admin-modal-content">
                        <h4>Change location</h4>
                        <hr />
                        <div className="form-group">
                            <label htmlFor="latitude">Latitude (between 49.9 and 60.0)</label>
                            <input
                                type="text"
                                className="form-control d-block"
                                placeholder={'Lat...'}
                                onChange={(e) => this.handleChange(e)}
                                onClick={(e) => this.stopPropagation(e)}
                                value={this.state.latitude}
                                name="latitude"
                                id="latitude"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="longitude">Longitude (between -8.0 and 2.0)</label>
                            <input
                                type="text"
                                className="form-control d-block"
                                placeholder={'Lng...'}
                                onChange={(e) => this.handleChange(e)}
                                onClick={(e) => this.stopPropagation(e)}
                                value={this.state.longitude}
                                name="longitude"
                                id="longitude"
                            />
                        </div>
                        <div className="form-group">
                            <button className="btn btn-cw-primary ml-2" onClick={(e) => this.savePostcode(e)}>
                                Save
                            </button>
                        </div>
                    </div>
                    <hr />
                    <div className="admin-notes-modal-footer">
                        <button className="btn btn-cw-primary" onClick={(e) => this.props.onHide(e, false)}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
